import { Context,XtLocale,Cookie,Request,Util,Storage } from "@xt/xtbase";
const {XtContext} = Context;
const {setHeader,XtAxios,XtAxios4} = Request;
const {getUrl,getUUID,doRsaEncrypt,getExplore,getPlatform} = Util;

const baseUrl = '/xt-message';

export const getNoticeList = (params) => XtAxios.get(`${baseUrl}/public/letter-notice/list`, {params});